//@ts-nocheck
//加时间戳防止cache
const res = await fetch('./xconfig-sn.json?t=' + new Date().getTime());
const envConfig = await res.json();
//把属性设置挂载到window.mpEnv 对象上
//如果配置文件中指定了环境 则首选它
const env = envConfig.env ?? process.env.VITE_ENV;
const targetProperties = envConfig[env];
window.mpEnv = targetProperties;
window.env = env;
import('./main');
export default {};
